/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Card_GroupsInputs */



/**
* | output |
* | --- |
* | "Groups" |
*
* @param {Community_Card_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_card_groups = /** @type {((inputs?: Community_Card_GroupsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Card_GroupsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Grupos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppi")
	return /** @type {LocalizedString} */ ("Groups")
});